import { setUser, socket } from "../index";

export interface SessionToken {
  id: string;
  expire: number;
  hash: string;
}

const emitAck = (
  sessionTokenData: SessionToken
) => {
  socket?.emit('ACK', sessionTokenData);
  setUser(sessionTokenData.id);
}

export default emitAck;